import { render, staticRenderFns } from "./categoryEdit.vue?vue&type=template&id=7dab2bd6&scoped=true"
import script from "./categoryEdit.vue?vue&type=script&lang=js"
export * from "./categoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab2bd6",
  null
  
)

export default component.exports